module.exports = __webpack_public_path__ + "img/tokyo-sauna.13c565d1.svg";